
<template>
<div class="grid-content">
    <div class="box parentflex">
        <p>{{title}}</p>
        <div class="count">
        <div class="pagebox">
            <ul class="countUl">
                <li style="background:rgba(122,41,204,0.6);color:#7A29cc;font-weight:bold;width:56px">Year</li>
                <li style="background:rgba(0,54,140,0.6);color:#00368C;font-weight:bold;width:106px">Month</li>
                <li style="background:rgba(230,191,0,0.6);color:#e6bf00;font-weight:bold;width:111px">Week</li>
                <li style="background:rgba(46,168,230,0.6);color:#2EA8E6;margin-right:0;font-weight:bold;width:170px">Day</li>
            </ul>
            <div id="bar"></div>
        </div>
        </div>
    </div>
</div>
</template>
<script>
import {getSlice} from "@/utils/index"
export default {
   props:{
        barDate:{//echarts数据
            type:Object,//类型对象
            require:true
        },
        title:{
            type:String,
            default:''
        }
    }, 
  data () {
    return {
        myChart:"",
        objdata:''
    };
  },
  created() {
      
  },
  mounted() {
    
  },
  watch:{
      barDate: {
         handler(newVal, oldVal){
            this.objdata =this.initData(newVal)
            this.fillYearEcharts(this.objdata)
        },
         deep: true
    }
  },
  methods: {
      initData(curval){
          let obj=  {
            x:curval.xdata,
            series:[{
                name:'Year',
                type:'bar',
                data:(function(){
                        let _data=curval.ydata[0]
                        let dataArr=[]
                        for(let i=0;i<_data.length;i++){
                            dataArr.push(_data[i].value)
                        }
                        return dataArr
                    }
                )(),
                label:{
                    show:true,
                    position:"top",
                    color:"#8A9099"
                },
                stack:"bar"
            },{
                name:'Month',
                type:'bar',
                data:(function(){
                    let _data=curval.ydata[1]
                    let dataArr=[]
                    for(let i=0;i<2;i++){
                        dataArr.push('-')
                    }
                    for(let i=0;i<_data.length;i++){
                        dataArr.push(_data[i].value)
                    }
                    return dataArr
                    }
                )(),
                label:{
                    show:true,
                    position:"top",
                    color:"#8A9099"
                },
                stack:"bar"
            },{
                name:'Week',
                type:'line',
                data:(function(){
                    let _data=curval.ydata[2]
                    let dataArr=[]
                    for(let i=0;i<7;i++){
                        dataArr.push('-')
                    }
                    for(let i=0;i<_data.length;i++){
                        dataArr.push(_data[i].value)
                    }
                    return dataArr
                    }
                )(),
                symbol:"circle",
                symbolSize:8,
                showAllSymbol:true,
                label:{
                    show:true,
                    position:"top",
                    color:"#8A9099"
                },
                stack:"bar"
            },{
                name:'Day',
                type:'line',
                data:(function(){
                    let _data=curval.ydata[3]
                    var dataArr=[]
                    for(let i=0;i<12;i++){
                        dataArr.push('-')
                    }
                    for(let i=0;i<_data.length;i++){
                        dataArr.push(_data[i].value)
                    }
                    return dataArr
                    }
                )(),
                symbol:"circle",
                showAllSymbol:true,
                symbolSize:8,
                stack:"bar",
                label:{
                    show:true,
                    position:"top",
                    color:"#8A9099"
                },
            }]
        }
        return  obj
      },
     fillYearEcharts(obj){
        let this_ = this;
        if (this_.myChart != null && this_.myChart != "" && this_.myChart != undefined) {
            this_.myChart.dispose();
        }
         this.myChart = this.$echarts.init(document.getElementById("bar"));
        var option = {
            tooltip: {
                trigger: 'axis',
                confine:true,
                formatter:function(params){
                    return params[0].axisValue+"<br/>"+params[0].marker+params[0].seriesName+":"+params[0].data;
                }
            },
            color:["#7A29CC","#00368c","#e6bf00","#2EA8E6","#DC143C"],
            grid: {
                left: '1%',
                right: '5%',
                bottom: '15%',
                top:'10%',
                show:true,
                borderColor:"#dce1e7",
                containLabel: true
            },
            legend: {
                data:['Year','Month','Week','Day'],
                show:false
            },
            xAxis: [{
                type: 'category',
                data:obj.x,
                axisLabel:{
                    color:"#8A9099",
                    fontSize:10,
                    fontFamily:"FZLTHJW",
                    interval:0,
                    rotate:-30
                },
                axisTick:{
                    show:true,
                    alignWithLabel:true
                },
                axisLine:{
                    show:true
                },
            }],
            yAxis: [{
                type: 'value',
                axisLabel:{
                    color:"#8A9099",
                    fontSize:10,
                    fontFamily:"FZLTHJW"
                },
                axisTick:{
                    show:false
                },
                axisLine:{
                    show:false
                },
                splitLine:{
                    lineStyle:{
                        color:["#dce1e7"]
                    }
                }
            }],
            series:obj.series
        };
        this_.myChart.setOption(option,true);
            if(this_.myChart){
                window.addEventListener("resize",function(){
                    this_.myChart.resize();
                });
            }
        }
  }
}

</script>
<style lang="scss" scoped>
.pagebox{width:100%;height:100%;overflow: hidden;}
#bar{width:100%;height:calc(100% - 20px);overflow: hidden;}
.grid-content{width:100%;height:100%;overflow: hidden;background: #fff;box-shadow:0 0 10px 2px #CCD7E8;border: 1px solid #CCD7E8;border-radius: 10px;text-align: left;}
.count{position:absolute;top:2.3rem;left:0;right:0;bottom:0;background:#fff;box-shadow:0 0 10px 2px #CCD7E8;box-sizing:border-box;}
.countUl{list-style:none;overflow:hidden;display:flex;margin-left:5%;margin:0px;height:20px;margin-top: 11px;padding-left: 26px;}
.countUl li{font-size:0.1rem;line-height:1.2rem;box-sizing:border-box;margin-right:10px;text-align:center;width:100px}
.parentflex{position: relative;padding:5px;box-sizing:border-box;background: #fff;padding-top:1px}
.parentflex>p{width:100%;height:2.2rem;line-height:2.2rem;font-size:1.4rem;padding-left:1rem;font-weight:bold;-webkit-box-sizing:border-box;box-sizing:border-box;}
.content{position: absolute;top:35px;bottom:5px;left: 5px;right: 5px;}
.box{width:100%;height:100%;overflow: hidden;padding: 10px;box-sizing: border-box;padding-top:1px}
canvas{height:100%}
</style>